import { Component, Renderer2, ChangeDetectorRef, signal } from "@angular/core";
import { Router, RouterLink } from "@angular/router";
import { ActivatedRoute, Params } from "@angular/router";
import { FormControl, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { ValidationService } from "../service/validation.service";
import { AuthService } from "../service/auth.service";
import { AnalyticsService } from "../service/analytics.service";
import { GeneralService } from "../service/general.service";
import { AbstractComponent } from "./abstract/abstract.component";
import { User } from "../entity/User";
import { Company } from "../entity/Company";
import { Account } from "../entity/Account";
import { State } from "../entity/State";
import { Utility } from "../entity/Utility";
import { RateClass } from "../entity/RateClass";
import { HeaderComponent } from "./incs/header.component";
import { NgxMaskDirective } from "ngx-mask";
import { ConfirmationDialog } from "./incs/confirmation-dialog.component";
import { Pair } from "../obj/Pair";

@Component({
    selector: "kilowant-register",
    templateUrl: "../../html/main-register.html",
    imports: [HeaderComponent, FormsModule, NgxMaskDirective, ReactiveFormsModule, RouterLink]
})
export class RegisterComponent extends AbstractComponent {
    waitlistForm: boolean = false;
    user: User = new User();
    step: number = 1;
    password: string = "";
    password2: string = "";
    passwordType: string = "password";
    passwordType2: string = "password";

    showPrivateText: boolean = true;

    currentPhoneNumber: FormControl = new FormControl("");

    fileToUpload: File = null!;
    deleteTaxExemptCertificateDocument: boolean;

    showJoinWhiteList: boolean = false;

    cities = signal<string[]>([]);

    hasCompany: boolean = null!;
    registrationCompleted: boolean = false;
    marketType: string;

    utility: Utility;
    utilities: Utility[] = [];
    rateClass: RateClass;
    rateClasses: RateClass[] = [];
    allRateClasses: RateClass[] | null = null;

    allStates = signal<State[]>([]);
    name: string;
    email: string;
    city: string;
    state: string | null = null;
    companyName: string | null = null;

    dialogRef: MatDialogRef<ConfirmationDialog> = null!;

    constructor(
        router: Router,
        route: ActivatedRoute,
        dialog: MatDialog,
        analyticsService: AnalyticsService,
        generalService: GeneralService,
        private renderer: Renderer2,
        public authService: AuthService,
        public validationService: ValidationService
    ) {
        super(router, route, dialog, analyticsService, generalService);
    }

    ngOnDestroy() {
        super.ngOnDestroy();
    }

    ngOnInit(): void {
        this.analyticsService.trackEvent("Registration Page", "User Opens Registration Page", "OPEN_PAGE");
        this.initPromises.push(this.generalService.getStates(true)
            .then(states => this.allStates.set(states)));
        this.initPromises.push(this.selectUtility());
        this.route.queryParams.forEach((params: Params) => {
            let data: string = params["join"];
            if (data != null && data == "true") {
                this.joinWaitList();
            }
        });
        super.ngOnInit();
    }

    pageStart(): void {
        if (this.authService.isLoggedIn()) {
            this.analyticsService.trackEvent("Registration Page", "User trys to register second time", "ERROR");
            this.router.navigate(["user/home"]);
            return;
        }
        this.user.isSupplier = false;
        this.user.isAdvisor = false;
    }

    showPassword(num: number) {
        if (num == 1) {
            if (this.passwordType === "password") {
                this.passwordType = "text";
            } else {
                this.passwordType = "password";
            }
        } else {
            if (this.passwordType2 === "password") {
                this.passwordType2 = "text";
            } else {
                this.passwordType2 = "password";
            }
        }
    }

    selectMarketType(marketType: string): void {
        if (this.marketType == marketType) {
            this.marketType = null!;
        } else if (this.marketType == null || this.marketType.length == 0) {
            this.marketType = marketType;
        } else if (this.marketType == "both") {
            if (marketType == "residential") {
                this.marketType = "commercial";
            } else {
                this.marketType = "residential";
            }
        } else {
            this.marketType = "both";
        }
        if (this.marketType == null || this.marketType.length == 0) {
            this.step = 2;
        } else {
            if (this.step < 3) {
                this.step = 3;
            }
        }
    }

    selectUtility(): Promise<Utility[]> {
        return <Promise<Utility[]>>this.generalService.getUtilities(this.generalService.getDefaultFuelType(), true, false, null).then((utilities) => {
            this.utilities = utilities;
            let u = this.generalService.getDefaultUtilityFromList(this.utilities);
            if (u != null) {
                this.utility = u;
            }
            this.reloadUtilityBasedData();
        });
    }

    reloadUtilityBasedData(): void {
        if (this.utility != null) {
            this.user.state = this.utility.state;
        }
        if (this.utility != null && this.allRateClasses == null) {
            this.generalService.getRateClasses(this.utility).then((rateClasses: any) => {
                this.allRateClasses = rateClasses;
            });
            this.filterCities();
        } else {
            this.filterCities();
        }
    }

    filterCities(): void {
        if (this.user.state == null) {
            this.cities.set([]);
            return;
        }
        this.generalService.getCities(this.user.state).then((cities) => {
            this.cities.set(cities);
        });
    }

    sendForm(step: number): void {
        this.clearErrors();
        this.waitlistForm = false;

        if (this.user.firstName == null || this.user.firstName.length == 0) {
            this.addError("FirstName");
        }
        if (this.user.lastName == null || this.user.lastName.length == 0) {
            this.addError("LastName");
        }
        if (this.currentPhoneNumber.value == null || this.currentPhoneNumber.value.length == 0) {
            this.addError("Phone");
        }
        if (!this.user.isSupplier) {
            if (this.user.addressLine1 == null || this.user.addressLine1 == "") {
                this.addError("addressLine1");
            }
            if (this.user.state == null) {
                this.addError("stateId");
            }
            if (this.user.zip == null || this.user.zip == "") {
                this.addError("zip");
            }
            if (this.user.city == null || this.user.city == "") {
                this.addError("city");
            }
        }

        this.user.company = null!;
        if (this.user.email == null || this.user.email.length == 0) {
            this.addError("Email");
        }
        if (this.password == null || this.password.length == 0) {
            this.addError("Password");
        }
        if (this.password2 == null || this.password2.length == 0) {
            this.addError("Password2");
        }
        if (!this.currentPhoneNumber.valid) {
            this.addError("Phone");
            this.setErrorText("Phone number is not correct.");
            return;
        }
        this.user.phone = this.currentPhoneNumber.value;
        if (this.errorY().showError()) {
            this.setErrorText("Please enter the data requested above in order to register.");
            this.analyticsService.trackEvent("Error In Form Registration", "User gets an error on the form to register: [" + this.errorY().error + "] on the Registration Page", "FORM_ERROR");
            return;
        }
        if (this.password != this.password2) {
            this.setErrorText("Passwords do not match.");
            this.addError("Password");
            this.addError("Password2");
            this.analyticsService.trackEvent("Error In Form Registration", "User gets an error on the form to register: [" + this.errorY().error + "] on the Registration Page", "FORM_ERROR");
            return;
        }

        if (this.companyName != null && this.companyName.length > 0) {
            this.user.company = new Company();
            this.user.company.name = this.companyName;
            this.user.company.state = this.user.state!;
            this.user.company.city = this.user.city!;
            this.user.company.zip = this.user.zip!;
            this.user.company.addressLine1 = this.user.addressLine1!;
            this.user.company.addressLine2 = this.user.addressLine2!;
            this.user.company.phone = this.user.phone!;
            this.user.company.name = this.companyName;
        }
        this.generalService.checkRegisterUserEmail(this.user.email).subscribe(
            {
                next: (response: any) => {
                    this.dialogRef = this.dialog.open(ConfirmationDialog, {
                        disableClose: false
                        , panelClass: "i-icon-popup"
                    });
                    this.dialogRef.componentInstance.confirmTitle = "Please Confirm Your Email";
                    this.dialogRef.componentInstance.confirmMessage = this.user.email;
                    this.dialogRef.componentInstance.cancelButton = "Change";
                    this.dialogRef.afterClosed().subscribe((result: any) => {
                        if (result) {
                            this.proceedRegisterUser();
                        }
                        this.dialogRef = null!;
                    });
                },
                error: (err: any) => {
                    if (err.status == 400) {
                        this.addError("email");
                        this.setErrorText(err.error);
                        this.analyticsService.trackEvent("Error In Form Registration", "User gets an error on the form to register: [" + this.errorY().error + "] on the Registration Page", "FORM_ERROR");
                    }
                }
            }
        );
    }

    proceedRegisterUser(): void {
        this.generalService.registerUser(this.user, null, this.password, null, false)
            .subscribe({
                next: (res: any) => {
                    if (res) {
                        this.authService.login(this.user.email, this.password).subscribe(
                            {
                                next: (response: Pair) => {
                                    this.router.navigate(["account/onboarding"]);
                                    return;
                                },
                                error: (err: any) => {
                                    if (err.status == 400) {
                                        this.setErrorText(err.error);
                                        this.analyticsService.trackEvent("Error In Form Registration", "User gets an error on the form to register: [" + this.errorY().error + "] on the Registration Page", "FORM_ERROR");
                                    }
                                }
                            }
                        );
                    }
                },
                error: (err: any) => {
                    if (err.status == 400) {
                        this.setErrorText(err.error);
                        this.analyticsService.trackEvent("Error In Form Registration", "User gets an error on the form to register: [" + this.errorY().error + "] on the Registration Page", "FORM_ERROR");
                    }
                }
                });
    }

    joinWaitList(): void {
        this.showJoinWhiteList = !this.showJoinWhiteList;
    }

    joinWeblistSubmit(): void {
        this.clearErrors();
        this.waitlistForm = true;
        if (this.name == null || this.name.length == 0) {
            this.addError("name");
        }
        if (this.email == null || this.email.length == 0) {
            this.addError("email");
        }

        if (this.errorY().showError()) {
            this.setErrorText("Please enter the data requested above in order to join our waitlist.");
            this.analyticsService.trackEvent("Error In Form Join Weblist", "User gets an error on the form to join weblist: [" + this.errorY().error + "] on the Registration Page", "FORM_ERROR");
            return;
        }

        this.generalService.send({
            state: this.state, name: this.name, email: this.email
        }).subscribe((res: any) => {
            this.registrationCompleted = true;
        },
            err => {
                if (err.status == 400) {
                    this.addError("email");
                    this.setErrorText(err.error);
                    this.analyticsService.trackEvent("Error In Form Join Weblist", "User gets an error on the form to join weblist: [" + this.errorY().error + "] on the Registration Page", "FORM_ERROR");
                }
            }
        );
    }

    trackButtonClick(info: string): void {
        this.analyticsService.trackEvent("Button click: " + info, "User Clicks Button: [" + info + "] on the Registration Page", "BUTTON_CLICK");
    }
}
